module.exports = __webpack_public_path__ + "img/Alejandro_Ramirez.9a5ba345.jpg";